export var V0AnswerTypes;
(function (V0AnswerTypes) {
    V0AnswerTypes["string"] = "string";
    V0AnswerTypes["text"] = "text";
    V0AnswerTypes["singleChoice"] = "singleChoice";
    V0AnswerTypes["multipleChoice"] = "multipleChoice";
    V0AnswerTypes["number"] = "number";
    V0AnswerTypes["date"] = "date";
    V0AnswerTypes["label"] = "label";
})(V0AnswerTypes || (V0AnswerTypes = {}));
